import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ZbsValuelistEntries } from '../../../services/Ebootis.Queries/ZbsValuelistEntries';

@Component({
  selector: 'app-zbs-valuelist-entry-select',
  templateUrl: './zbs-valuelist-entry-select.component.html',
  styleUrls: ['./zbs-valuelist-entry-select.component.scss']
})
export class ZbsValuelistEntrySelectComponent {

  @Input('ctrl')
  public m_ctrl: FormControl<string>;
  @Input('required')
  public m_required: boolean;

  @Input() set zbsConfigOid(p_configOid: string) {
    this.m_zbsEntries$ = this.query.query({ zbsConfig: p_configOid });
  }

  public m_zbsEntries$: Observable<ZbsValuelistEntries.Result[]>;

  constructor(
    private query: ZbsValuelistEntries
  ) { }

}
